import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { DownloadIcon } from "~/components/ui/icons/download";
import { Loader } from "~/components/ui/loader";
import { toast } from "~/components/ui/toast";
import { useGeneratePurchaseOrderMutation } from "~/graphql/graphql-new.gen";

type OrderPurchaseOrderProps = {
  orderId: string;
};

const downloadURI = (uri: string) => {
  const link = document.createElement("a");
  // If you don't know the name or want to use
  // the webserver default set name = ''
  link.setAttribute("download", "download");
  link.href = uri;
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const OrderPurchaseOrder: React.FC<OrderPurchaseOrderProps> = ({
  orderId,
}) => {
  const { t } = useTranslation();

  const { mutateAsync, isPending, error } = useGeneratePurchaseOrderMutation();

  useEffect(() => {
    if (error) {
      toast.error(t("order.purchase_order.generate_purchase_order_error"));
    }
  }, [error]);

  return (
    <div className="space-y-2">
      {isPending ? (
        <Loader className="size-4" />
      ) : (
        <button
          type="button"
          className="flex gap-x-1 text-xs font-semibold text-green-900"
          onClick={async () => {
            const { generatePurchaseOrder } = await mutateAsync({
              orderId,
            });
            downloadURI(generatePurchaseOrder.url);
          }}
        >
          <DownloadIcon className="size-4" />
          {t("order.purchase_order.download_purchase_order")}
        </button>
      )}
      <p className="text-xs text-[#767A7C]">
        {t("order.purchase_order.carrier_only")}
      </p>
    </div>
  );
};
